function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/* eslint semi: ["error", "never"]*/

/* eslint arrow-parens: ["error", "as-needed"]*/

/* eslint key-spacing: ["error", { "afterColon": true, "align": "value" }] */

/* eslint no-multi-spaces: ["error", { exceptions: { "ImportDeclaration": true,
                                       "VariableDeclarator": true  } }] */
import Checkbox from '@engine/components/presentational/base/checkbox';
import ManagedRecurring from '@engine/features/virtual_terminal/vt_managed_recurring';
import React from 'react';
import { connect } from 'react-redux';
import { updateVtFormData } from '@engine/actions/creators/virtual-terminal';
var FEATURES_TO_DISPLAY = ['moto', 'gaming', 'crypto', 'issuer_oct_enabled', 'preauthorization'];

var DetailsContainer = /*#__PURE__*/function (_React$Component) {
  _inherits(DetailsContainer, _React$Component);

  var _super = _createSuper(DetailsContainer);

  function DetailsContainer(props) {
    var _this;

    _classCallCheck(this, DetailsContainer);

    _this = _super.call(this, props);

    if (Object.keys(props.features).length !== 0) {
      _this.props.updateVtFormData(props.features);
    }

    return _this;
  }

  _createClass(DetailsContainer, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props$configure, _prevProps$configure_;

      var isVisible = (_this$props$configure = this.props['configure_new_managed_recurring']) === null || _this$props$configure === void 0 ? void 0 : _this$props$configure.visible;

      if (!isVisible && (_prevProps$configure_ = prevProps['configure_new_managed_recurring']) !== null && _prevProps$configure_ !== void 0 && _prevProps$configure_.visible) {
        ManagedRecurring.updateFields(false);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this,
          _this$props$configure2;

      return React.createElement("div", {
        className: "row"
      }, FEATURES_TO_DISPLAY.map(function (feature) {
        var _this2$props$feature, _this2$props$feature2;

        return ((_this2$props$feature = _this2.props[feature]) === null || _this2$props$feature === void 0 ? void 0 : _this2$props$feature.visible) && React.createElement("div", {
          key: feature,
          className: "col-sm-4 col-xs-6"
        }, React.createElement(Checkbox, {
          name: _this2.getFieldName(feature),
          value: Boolean((_this2$props$feature2 = _this2.props[feature]) === null || _this2$props$feature2 === void 0 ? void 0 : _this2$props$feature2.value) || false,
          labelText: I18n.t("object.attributes.".concat(feature)),
          identifier: "".concat(_this2.prefix, "_").concat(feature),
          onChange: function onChange(_attr, value) {
            _this2.props.updateVtFormData(_defineProperty({}, feature, {
              value: value
            }));
          }
        }));
      }), ((_this$props$configure2 = this.props['configure_new_managed_recurring']) === null || _this$props$configure2 === void 0 ? void 0 : _this$props$configure2.visible) && React.createElement("div", {
        className: "col-sm-8 col-xs-6"
      }, React.createElement(Checkbox, {
        name: "configure_new_managed_recurring",
        value: Boolean(this.props['configure_new_managed_recurring'].value) || false,
        labelText: I18n.t('actions.object.configure_new', {
          obj: I18n.t('object.names.managed_recurring_item')
        }),
        identifier: "configure_new_managed_recurring",
        onChange: function onChange(_attribute, value) {
          ManagedRecurring.updateFields(value);

          _this2.props.updateVtFormData({
            configure_new_managed_recurring: {
              value: value
            }
          });
        }
      })));
    }
  }, {
    key: "getFieldName",
    value: function getFieldName(feature) {
      return "".concat(this.prefix, "[").concat(feature, "]");
    }
  }, {
    key: "prefix",
    get: function get() {
      return "".concat(this.props.transactionType, "_transaction");
    }
  }]);

  return DetailsContainer;
}(React.Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    moto: state.virtualTerminalFormData.moto,
    gaming: state.virtualTerminalFormData.gaming,
    crypto: state.virtualTerminalFormData.crypto,
    issuer_oct_enabled: state.virtualTerminalFormData.issuer_oct_enabled,
    preauthorization: state.virtualTerminalFormData.preauthorization,
    transactionType: state.virtualTerminalFormData.transactionType,
    configure_new_managed_recurring: state.virtualTerminalFormData.configure_new_managed_recurring
  };
};

export default connect(mapStateToProps, {
  updateVtFormData: updateVtFormData
})(DetailsContainer);